module.exports = __webpack_public_path__ + "img/palacio_03.53e807cd.jpg";